import {Imagen1, Imagen2, Imagen3, Imagen4, Imagen5, Imagen6 } from '../img/opinions/'
const Opinions =[
    {
        persone:'Anastasiya Ivanova',
        img:Imagen1,
        opinion:'Lusine is a fantastic photographer. She really has an eye for capturing the perfect shot and made us feel so comfortable during our session.',
    },
    {
        persone:'Maria Petrova',
        img:Imagen2,
        opinion:'I absolutely love the photos that Lusine took of my family. She captured all of our personalities and the memories we made that day beautifully.',
    },
    {
        persone:'Oksana Kovalenko',
        img:Imagen3,
        opinion:'Working with Lusine was such a pleasure. She was professional, patient and really took the time to understand what we were looking for in our photos.',
    },
    {
        persone:'Yana Tkachenko',
        img:Imagen4,
        opinion:'Lusine is simply amazing. She took my headshot for my business and I have received so many compliments on how professional and stunning it looks.',
    },
    {
        persone:'Kateryna Kozlova',
        img:Imagen5,
        opinion:'I highly recommend Lusine for any photography needs. She has a talent for capturing natural, candid moments that truly tell a story.',
    },
    {
        persone:'Daria Zaitseva',
        img:Imagen6,
        opinion:'Lusine is a true artist. She takes the time to get to know her clients and the end result is always a masterpiece.',
    },
]
export default Opinions;